import API_BASE from "../config.js";
import React from "react";
import Layout from "../components/Layout";
import { Dica, BotaoDica } from "../components/Dica";
import { useTranslation } from "react-i18next";

export default function Manual() {
  const { t } = useTranslation();
  return (
    <Layout>
      <div style={{display:"flex",flexDirection:"column",gap:20,maxWidth:900,margin:"0 auto"}}>
        <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between"}}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{fontSize:22,fontWeight:700}}>{t("manual.titulo")}</h1><BotaoDica id="manual" /></div>
            <p style={{color:"var(--text2)",fontSize:13,marginTop:3}}>{t("manual.subtitulo")}</p>
          </div>
          <a href={API_BASE + "/manual"} target="_blank" rel="noreferrer"
            style={{background:"linear-gradient(135deg,var(--accent),#6366f1)",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 20px",textDecoration:"none"}}>
            {t("manual.abrir_tela_cheia")}
          </a>
        </div>
        <Dica id="manual" jaUsou={false} texto={t("dicas.manual")} />

        <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:12,overflow:"hidden",width:"100%"}}>
          <iframe
            title={t("manual.titulo")}
            src={API_BASE + "/manual"}
            style={{border:"none",height:"75vh",width:"100%"}}
          />
        </div>
      </div>
    </Layout>
  );
}
